import { useEffect, useRef, useState } from 'react'

/*
使用：
    ref={useScrollToBottom(() => {
      console.log('已经滚动到底部')
      // 这里可以执行你需要的动作
    })}
**/

const useScrollToBottom = (onBottomReached) => {
  const [bottomReachedCalled, setBottomReachedCalled] = useState(false)
  const scrollRef = useRef(null)

  useEffect(() => {
    const handleScroll = () => {
      const { scrollTop, scrollHeight, clientHeight } = scrollRef.current
      if (bottomReachedCalled) {
        // 如果scrollTop + clientHeight小于scrollHeight - 50，重置状态
        if (scrollTop + clientHeight < scrollHeight - 50) {
          setBottomReachedCalled(false)
        }
        return
      }

      if (
        scrollTop + clientHeight >= scrollHeight - 50 &&
        scrollTop + clientHeight <= scrollHeight + 50
      ) {
        onBottomReached()
        setBottomReachedCalled(true)
      }
    }

    if (scrollRef.current) {
      scrollRef.current.addEventListener('scroll', handleScroll)
    }

    return () => {
      if (scrollRef.current) {
        scrollRef.current.removeEventListener('scroll', handleScroll)
      }
    }
  }, [onBottomReached])

  return scrollRef
}

export default useScrollToBottom
